import { filters } from "@/filters";
import { $filters } from "@/stores/filters";
import { $map } from "@/stores/map";
import { useStore } from "@nanostores/react";
import { useEffect, useRef } from "react";
import { DataMap } from "./maplibre";

export function useMap<T extends HTMLElement>() {
  const mapRef = useRef<T | null>(null);

  const map = useRef<DataMap | null>(null);
  const _filters = useStore($filters);
  const _map = useStore($map)

  useEffect(() => {
    if (!mapRef.current) {
      throw new Error("Map container is not set");
    }
    const dataMap = new DataMap();
    map.current = dataMap;
    map.current.init(mapRef.current);
  }, []);

  useEffect(() => {
    if (!map.current || !_map.initialized) {
      return;
    }
    try {
      map.current.filter(filters);
    } catch (e) {
      console.error(e);
    }
  }, [filters, _filters]);

  return mapRef;
}
